<template>
  <mcs-sheet
    no-padding
    class="border-rounded-none"
  >
    <div class="d-flex">
      <v-sheet class="greyLight pa-2 my-auto">
        <v-img
          :src="item.finalImageUrl || item.partImageUrl"
          width="130"
          contain
        />
      </v-sheet>
      <div class="pl-4">
        <div class="body-1 font-weight-bold">
          {{ item.productName }}
        </div>
        <div class="body-2 mt-2">
          <div>Qty {{ item.quantity | separator }}</div>
          <div>{{ item.partName }}</div>
          <template v-if="item.isDecorated">
            <div>{{ item.locationName }}</div>
            <div>{{ item.decorationName }}</div>
            <div>{{ item.decorationColorName }}</div>
            <div v-if="item.includeProof">Proof included</div>
          </template>
          <div v-else>Blank</div>
          <template v-if="item.addressId">
            <div class="font-weight-bold mt-2">Ship to:</div>
            <div>
              {{ address(item.addressId).firstName }} {{ address(item.addressId).lastName }}
            </div>
            <div v-if="address(item.addressId).company">
              {{ address(item.addressId).company }}
            </div>
            <div>
              {{ address(item.addressId).line1 }} {{ address(item.addressId).city }}
              {{ address(item.addressId).state }}, {{ address(item.addressId).postalCode }}
            </div>
          </template>
          <div
            v-if="item.delivery"
            class="mt-2"
          >
            <div class="font-weight-bold">Estimated Delivery:</div>
            <div v-if="item.delivery.valid">
              {{ item.delivery.earliestDate | regularDateNoYear }} -
              {{ item.delivery.latestDate | regularDateNoYear }}
            </div>
            <mcs-chip
              v-else
              color="accentLight"
              append-icon="mdi-alert-circle"
              @click="$emit('edit-shipping')"
            >
              Change delivery date
            </mcs-chip>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-4">
      <mcs-chip
        color="white"
        append-icon="mdi-pencil"
        class="my-auto mr-2"
        @click="$emit('edit')"
      >
        Edit Order
      </mcs-chip>
      <mcs-chip
        class="my-auto"
        color="white"
        append-icon="mdi-close"
        :loading="deletingItemId === item.id"
        @click="deleteItem(item)"
      >
        Remove
      </mcs-chip>
      <div class="my-auto ml-auto body-1">
        <div class="d-flex align-center font-weight-bold">
          <div
            v-if="item.subTotalPriceOriginal > item.subTotalPrice"
            class="text-decoration-line-through mr-2"
          >
            {{ item.subTotalPriceOriginal | currency }}
          </div>
          <div :class="{ 'success--text': item.subTotalPriceOriginal > item.subTotalPrice }">
            {{ item.subTotalPrice | currency }}
          </div>
          <mcs-btn
            v-if="allowCosts"
            icon
            color="black"
            prepend-icon="mdi-eye-outline"
            class="ml-2"
            @click="showCosts = !showCosts"
          ></mcs-btn>
        </div>
      </div>
    </div>
    <v-expand-transition v-if="allowCosts">
      <v-sheet
        v-show="showCosts"
        outlined
        class="mt-0 px-4 body-2 mb-3"
        dense
      >
        <div class="d-flex justify-space-between w-full my-2">
          <div><b>Base:</b> {{ item.baseCost | currency }}</div>
          <div v-if="item.delivery.shippingCost">
            <b>Shipping:</b> {{ item.delivery.shippingCost | currency }}
          </div>
          <div v-if="item.delivery.salesTaxCost">
            <b>Taxes:</b> {{ item.delivery.salesTaxCost | currency }}
          </div>
          <div>
            <b>Profit:</b>
            {{
              (item.subTotalPrice -
                item.baseCost -
                item.delivery.shippingCost -
                item.delivery.salesTaxCost)
                | currency
            }}
          </div>
        </div>
      </v-sheet>
    </v-expand-transition>
  </mcs-sheet>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PromoCartItem',

  components: {},

  props: {
    item: { type: Object, default: () => {} }
  },

  data: () => ({
    deletingItemId: 0,
    showCosts: false
  }),

  computed: {
    address() {
      return (addressId) => {
        return this.addresses.find((x) => x.id === addressId) || {};
      };
    },
    allowCosts() {
      return this.isAdmin || !!this.runas;
    },
    scheduledRange() {
      return this.getScheduleRangeFormatted(this.item.delivery.earliestDate);
    },

    ...mapGetters({
      cart: 'printcart/cart',
      addresses: 'user/addresses',
      isAdmin: 'user/isAdmin',
      runas: 'config/runas'
    })
  },

  methods: {
    deleteItem(item) {
      this.deletingItemId = item.id;
      this.$store
        .dispatch('printcart/deletePromoItem', this.item.id)
        .then(() => {
          this.$emit('deleted');
        })
        .catch((error) => {
          this.$(error);
          this.$root.$alert('Error Occurred', 'An error occured while removing an item.');
        })
        .finally(() => {
          this.deletingItemId = 0;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
